import { RestaurantDescription } from "./RestaurantDescription";

export default RestaurantDescription;
